// extracted by mini-css-extract-plugin
export default {"dicePicker":"DiceGame_dicePicker__caLgc","sp":"DiceGame_sp__5R5rt"};